<mat-form-field class="flex w-full items-center">
  <mat-label>{{ placeholder | transloco }}</mat-label>
  <input
    type="text"
    matInput
    [ngClass]="{ '!text-gray-400': formControl.disabled === true }"
    [formControl]="searchFormControl"
    [matAutocomplete]="auto"
    class="flex-grow"
  />

  <div matSuffix class="flex items-center">
    @if (isLoading$ | async) {
      <mat-spinner
        [diameter]="18"
        class="mr-2"
      ></mat-spinner>
    }
    @if (formControl.disabled === false) {
      <button
        class="clear"
        type="button"
        mat-icon-button
        aria-label="Clear"
        (click)="clearSelection()"
      >
        <fa-icon [icon]="faTimes" size="xl"></fa-icon>
      </button>
    }
  </div>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayWith"
    (optionSelected)="selectionChange($event)"
    class="w-full"
  >
    @for (option of filteredData(); track option) {
      <mat-option [value]="option">
        {{ lableArgument ? option[lableArgument] : option }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
